// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__27vbK","gfeWrapper":"CalendarEvent_gfeWrapper__2hqy5"};